export default __webpack_public_path__ + "static/media/FrozenABC_01.c38411e1.png";